import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import { useLocation } from 'react-router-dom';

const UnderConstruction = () => {
  const location = useLocation();
  const { from } = location.state || { from: '' };

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          textAlign: 'center',
          padding: 3
        }}
      >
        <ConstructionIcon sx={{ fontSize: 100, color: 'warning.main', mb: 3 }} />
        <Typography variant="h2" component="h1" gutterBottom>
          Page en Construction
        </Typography>
        <Typography variant="h5" color="text.secondary" paragraph>
          Cette page est actuellement en cours de développement.
        </Typography>
        {from && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            Page demandée : {from}
          </Typography>
        )}
        <Typography variant="body1" color="text.secondary" sx={{ mt: 3 }}>
          Nous travaillons dur pour vous offrir une meilleure expérience. Merci de votre patience.
        </Typography>
      </Box>
    </Container>
  );
};

export default UnderConstruction;
